import React from 'react';

export const LayoutState = React.createContext({
    drawerOpen: true
});


export default LayoutState;
